module.exports = __webpack_public_path__ + "static/img/banner.adfa0bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NewcomerSignIn/banner.png
// module id = YOm/
// module chunks = 0